import { render, staticRenderFns } from "./SidebarControls.vue?vue&type=template&id=56c300f3&"
import script from "./SidebarControls.vue?vue&type=script&lang=js&"
export * from "./SidebarControls.vue?vue&type=script&lang=js&"
import style0 from "./SidebarControls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports